import _ from 'underscore';

export default class UserProductViewSpecs {
  constructor($scope, UserProductService) {
    $scope.$on('open_view_specs_dialog', function(event, args) {
      load_specs(args.user_product_id);
    });

    function load_specs(user_product_id) {
      UserProductService.get_multi_specs_for_admin_view(user_product_id).then(function(data) {
        _.each(data.specs, function(spec) {
          if (!spec.source) {
            spec.source = 6;
            spec.is_accurate = spec.is_accurate === true ? 1 : 0;
            spec.is_reels = spec.is_reels === true ? 1 : 0;
          }
        });
        $scope.dialog_specs = data.specs;
        $scope.dialog_combinations = data.combinations;
        $scope.open_dialog('view_specs_dialog');
      });
    }

    $scope.tabs = ['Reels Specs', 'Sheets Specs'];

    $scope.set_selected_tab = function(index) {
      $scope.selected_tab = index;
    };

    $scope.init = function() {
      $scope.selected_tab = 0;
      $scope.reels_substance_mode = 'both';
      $scope.reels_rw_mode = 'both';
      $scope.sheets_substance_mode = 'both';
      $scope._ = _;
    };

    $scope.init();
  }
}

UserProductViewSpecs.$inject = ['$scope', 'UserProductService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/user-product-view-specs.ctrl.js